<template>
  <div class="flex h-screen flex-col">
    <!--
      แถบประกาศต้องอยู่บนสุดและอยู่ใน flow ของ flex-col เพื่อดันทั้งหน้าลงมา
      ห้ามทำเป็น fixed ทับ ไม่งั้นปุ่มแถวบนของหน้าขายจะกดไม่โดน
    -->
    <SharedAnnouncementBar />

    <!-- Top nav-->
    <div
      v-if="onlineStatusStore.isOnline == false"
      class="relative flex h-8 bg-red-500 text-white text-center"
    >
      <p class="w-full text-lg">
        You are offline since {{ onlineStatusStore.offlineSince }}. (Please
        check internet connection)
      </p>
    </div>

    <!-- SHOW MAINTENANCE TOP BAR  (RED BG)-->
    <div v-if="false" class="relative flex min-h-9 items-center bg-red-600 px-4 text-white">
      <p class="w-full text-center text-sm font-semibold lg:text-base">
        ขออภัย ตอนนี้ระบบเกิดปัญหาขัดข้องในการเข้าใช้งาน ทางเจ้าหน้าที่กำลังเร่งตรวจสอบและแก้ไข
      </p>
    </div>
    <!-- จอเล็กไม่เห็นบรรทัดเวลาเปิดร้านใน navbar เลยต้องมีแถบแยก -->
    <NuxtLink
      v-if="!isUnassigned && jobsStore?.openShop && jobsStore.isOpenShopCrossDate"
      to="/dashboard?closeShop=1"
      class="flex min-h-8 items-center justify-center bg-red-600 px-4 text-center text-sm font-semibold text-white lg:hidden"
    >
      <i class="fa-sharp fa-solid fa-triangle-exclamation mr-2"></i>
      {{ $t("navbar.label.forgot_close") }}
      ({{ $t("navbar.label.start_pos") }}
      {{ displayDate(jobsStore.openShop.timestamp, "DD/MMM HH:mm") }})
    </NuxtLink>
    <header class="relative flex h-16 flex-shrink-0 items-center border-b border-gray-200 bg-white">
      <!-- Logo area -->
      <div class="absolute inset-y-0 left-0 lg:static lg:flex-shrink-0">
        <a
          href="#"
          class="flex h-16 w-16 items-center justify-center bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-600 lg:w-20"
        >
          <svg class="pl-4" aria-hidden="true" viewBox="0 0 52 25" fill="none">
            <path
              d="M18.724 1.714c-4.538 0-7.376 2.286-8.51 6.857 1.702-2.285 3.687-3.143 5.957-2.57 1.296.325 2.22 1.271 3.245 2.318 1.668 1.706 3.6 3.681 7.819 3.681 4.539 0 7.376-2.286 8.51-6.857-1.701 2.286-3.687 3.143-5.957 2.571-1.294-.325-2.22-1.272-3.245-2.32-1.668-1.705-3.6-3.68-7.819-3.68zM10.214 12c-4.539 0-7.376 2.286-8.51 6.857 1.701-2.286 3.687-3.143 5.957-2.571 1.294.325 2.22 1.272 3.245 2.32 1.668 1.705 3.6 3.68 7.818 3.68 4.54 0 7.377-2.286 8.511-6.857-1.702 2.286-3.688 3.143-5.957 2.571-1.295-.326-2.22-1.272-3.245-2.32-1.669-1.705-3.6-3.68-7.82-3.68z"
              class="fill-white"
            ></path>
          </svg>
        </a>
      </div>

      <!-- Desktop nav area -->
      <div
        class="hidden lg:flex lg:min-w-0 lg:flex-1 lg:items-center lg:justify-between"
      >
        <div class="min-w-0">
          <div class="relative max-w-2xl pl-4 focus-within:text-gray-500">
            <!-- <p class="text-lg">{{ shopName }}</p> -->
            <p class="text-md text-black font-bold">{{ shopName }}</p>
            <p
              v-if="jobsStore?.openShop"
              class="text-sm text-gray-600 space-x-2"
            >
              <span class="">{{ $t("navbar.label.start_pos") }} : </span>
              <span class=""
                >{{
                  displayDate(jobsStore?.openShop?.timestamp, "DD/MMM HH:mm")
                }}
              </span>
              <span
                v-if="runningTime"
                class="text-xs text-gray-500"
                >({{ $t("navbar.label.running") }} {{ runningTime }})</span
              >
              <span class="">Shift : {{ currentShift }}</span>
              <span v-if="computerId" class="" :title="`ComputerId : ${computerId}`">
                <i class="fa-sharp fa-solid fa-desktop mr-1 text-gray-500"></i>{{ computerId }}
              </span>
              <NuxtLink
                v-if="!isUnassigned && jobsStore.isOpenShopCrossDate"
                to="/dashboard?closeShop=1"
                class="inline-flex items-center rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white animate-pulse"
              >
                <i class="fa-sharp fa-solid fa-triangle-exclamation mr-1"></i>
                {{ $t("navbar.label.forgot_close") }}
              </NuxtLink>
            </p>
          </div>
        </div>
        <div class="ml-10 flex flex-shrink-0 items-center space-x-10 pr-4">
          <nav aria-label="Global" class="flex space-x-10 items-center">
            <div class="relative space-x-10 text-left flex flex-row w-70">
              <!-- <button
                type="button"
                @click="clearJobs"
                class="
                  flex
                  items-center
                  rounded-md
                  text-sm
                  border
                  p-2
                  font-medium
                  text-gray-900
                  focus:outline-none
                  focus:ring-2
                  focus:ring-blue-600
                  focus:ring-offset-2
                "
                id="menu-0-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span>Clear Jobs</span>
            
              </button> -->

              <!-- <div v-if="shopStore?.getExpiredDate" class="text-xs flex flex-col text-gray-500 justify-center">
              <span><b>Expire Date :</b> {{ shopStore?.getExpiredDate }}</span>             
            </div> -->

              <button
                type="button"
                @click="lockScreen"
                class="flex items-center rounded-md text-sm border p-2 font-medium text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 min-w-32"
                id="menu-0-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span v-if="employee" class="px-2"
                  >{{ employee?.name }}
                  <span class="text-gray-500 ml-4 font-light"
                    ><i class="fa-light fa-lock"></i>
                    {{ $t("navbar.btn.click_to_lock") }}</span
                  ></span
                >
                <span v-if="!employee">
                  {{ $t("navbar.btn.lock_screen") }}
                </span>
                <!-- Heroicon name: mini/chevron-down -->
              </button>
            </div>

            <div class="text-xs flex flex-col text-gray-500">
              <span
                >{{ $t("navbar.label.mode") }} : {{ posStore?.runmode }}</span
              >
              <span
                v-if="shopStore.displayExpiredDate"
                :class="{
                  'bg-yellow-300 text-gray-800': remainingExpireDate < 5,
                }"
                >{{ $t("navbar.label.expire_date") }} :
                {{ shopStore.displayExpiredDate }}
                <span v-if="shopStore.expireDate"
                  >{{ displayExpireDate }}
                </span>
              </span>
              <span v-else
                >{{ $t("navbar.label.store_id") }} :
                {{ shopStore?.storeId }}</span
              >
            </div>
          </nav>
          <div class="flex items-center space-x-8 pr-4">
            <button
              @click="navigateTo('/topup/promptpay')"
              type="button"
              class="flex items-center rounded-md text-sm border p-2 font-medium text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
              id="menu-0-button"
              aria-expanded="false"
              aria-haspopup="true"
            >
              <span class=""
                ><i class="fa-solid fa-qrcode"></i>
                {{ $t("navbar.btn.topup") }}</span
              >
            </button>
            <span v-if="false" class="inline-flex">
              <a
                href="#"
                class="-mx-1 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500"
              >
                <span class="sr-only">View notifications</span>
                <!-- Heroicon name: outline/bell -->
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                  />
                </svg>
              </a>
            </span>

            <div
              class="relative inline-block text-left"
              @mouseenter="hoverUserIcon = true"
              @mouseleave="hoverUserIcon = false"
            >
              <button
                type="button"
                class="flex rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 flex-col items-center"
                id="menu-1-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <i
                  class="h-8 w-8 pt-2 bg-gray-300 rounded-full fa-light fa-user"
                ></i>
                <!-- <img
                  class="h-8 w-8 rounded-full"
                  src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
                /> -->
              </button>

              <!--
              Dropdown menu, show/hide based on menu state.

              Entering: "transition ease-out duration-100"
                From: "transform opacity-0 scale-95"
                To: "transform opacity-100 scale-100"
              Leaving: "transition ease-in duration-75"
                From: "transform opacity-100 scale-100"
                To: "transform opacity-0 scale-95"
            -->
              <div
                @mouseenter="hoverUserIcon = true"
                @mouseleave="hoverUserIcon = false"
                class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                :class="{ hidden: !hoverUserIconDebounce }"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="menu-1-button"
                tabindex="-1"
              >
                <div class="py-1" role="none">
                  <!-- Active: "bg-gray-100", Not Active: "" -->
                  <a
                    @click="changeModePos"
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-1-item-0"
                    >{{ $t("navbar.menu.change_pos_mode") }}</a
                  >
                  <!-- เขียนสถานะโต๊ะล่าสุดทับขึ้น cloud ทั้งหมด — เฉพาะ Main cashier ที่ถือข้อมูลชุดจริง -->
                  <a
                    @click.prevent="syncToCloud"
                    href="#"
                    class="block px-4 py-2 text-sm"
                    :class="
                      canSyncToCloud
                        ? 'text-gray-700'
                        : 'text-gray-400 cursor-not-allowed'
                    "
                    :aria-disabled="!canSyncToCloud"
                    :title="
                      isMainCashier
                        ? ''
                        : $t('navbar.menu.sync_to_cloud_main_only')
                    "
                    role="menuitem"
                    tabindex="-1"
                    id="menu-1-item-sync"
                  >
                    <i
                      class="fa-light mr-1"
                      :class="
                        syncingToCloud ? 'fa-spinner fa-spin' : 'fa-cloud-arrow-up'
                      "
                    ></i>
                    {{ $t("navbar.menu.sync_to_cloud") }}
                    <span
                      v-if="!isMainCashier"
                      class="block text-xs text-gray-400"
                      >{{ $t("navbar.menu.sync_to_cloud_main_only") }}</span
                    >
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/xtable-882df.appspot.com/o/PrinterCommandsInstaller%2FPrinterServiceXtable.exe?alt=media&token=92b41d78-8f4f-440d-a77d-7966b455073c"
                    class="block px-4 py-2 text-sm text-gray-700"
                    target="_blank"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-1-item-0"
                    >{{ $t("navbar.menu.download_printer_interface") }}</a
                  >

                  <a
                    :href="mappingPrinterUrl"
                    target="_blank"
                    class="block px-4 py-2 text-sm text-gray-700"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-1-item-0"
                    >{{ $t("navbar.menu.mapping_printers") }}</a
                  >

                  <a
                    @click="logout"
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700"
                    role="menuitem"
                    tabindex="-1"
                    id="menu-1-item-1"
                    >{{ $t("navbar.menu.sign_out") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="flex min-h-0 flex-1 overflow-hidden h-screen">
      <!-- Narrow sidebar-->
      <nav
        aria-label="Sidebar"
        :style="{ _height: HEIGHT_REMAINING + 'px', background: '#eaf1fb' }"
        class="block lg:flex-shrink-0 lg:overflow-y-auto border-r border-gray-200 h-screen flex flex-col"
      >
        <div class="relative flex w-20 flex-col space-y-3 p-3">
          <NuxtLink
            v-for="item in navList"
            :key="item.name"
            :to="item.link"
            @click="activeNav = item.name"
            
          >
            <a            
              href="#"
              class="text-white flex-shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg flex flex-col text-center"
              :class="item.name === activeNav ? 'bg-[#d3e3fd]' : ''"
            >
              <!-- Heroicon name: outline/inbox -->
              <i class="text-lg text-gray-700" :class="item.icon"></i>

              <!-- <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
                />
              </svg> -->
              <span class="text-xs text-gray-700" style="fontsize: 0.6rem">{{
                item.name
              }}</span>
            </a>
          </NuxtLink>
        </div>

        <div class="absolute bottom-5 left-5 flex-1 text-xs text-gray-500 text-center">
          <!-- -mx-2 -my-1 กันไม่ให้ padding ที่เพิ่มไปดันตำแหน่งเลขเวอร์ชันเคลื่อน -->
          <div
            class="-mx-2 -my-1   select-none rounded px-2 py-1 hover:bg-gray-100 hover:text-gray-700"
            @click="tapVersion"
          >
            v{{ packageData.version }}
          </div>

          <!-- ซ่อนไว้ กดเลขเวอร์ชัน 5 ครั้งภายใน 5 วินาทีถึงจะโผล่ -->
          <div
            v-if="showBuildInfo"
            class="mt-1 w-52 select-none rounded border border-gray-300 bg-white px-2 py-1.5 text-left leading-5 shadow"
            @click="showBuildInfo = false"
          >
            <div class="mb-1 border-b border-gray-200 pb-1 font-semibold text-gray-600">
              Build Info
            </div>

            <div class="grid grid-cols-[4.5rem_1fr] gap-x-1">
              <span class="text-gray-500">Version</span>
              <span class="text-gray-700">v{{ packageData.version }}</span>

              <span class="text-gray-500">Channel</span>
              <span class="text-gray-700">{{ buildChannel }}</span>

              <span class="text-gray-500">Tag</span>
              <span class="text-gray-700">{{ buildInfo.tag || "— (no tag)" }}</span>

              <span class="text-gray-500">Commit</span>
              <span class="font-mono text-gray-700">{{ buildInfo.commit || "—" }}</span>

              <span class="text-gray-500">Branch</span>
              <span class="text-gray-700">{{ buildInfo.branch || "—" }}</span>

              <span class="text-gray-500">Built</span>
              <span class="text-gray-700">{{ buildAt || "—" }}</span>
            </div>

            <div v-if="buildInfo.dirty" class="mt-1 text-amber-600">
              Built with uncommitted changes
            </div>
          </div>
        </div>
      </nav>

      <!-- Main area -->
      <main
        class="min-w-0 flex-1 xl:flex overflow-auto"
      >
        <slot></slot>
      </main>
    </div>

    <SharedToast />
    <ModalEmployeePin />
    <SharedAppReload />
    <ModalSessionStale />
    <SharedLoading v-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import { JobAction } from "~/interface/Job";
import packageData from "~/package.json";
import  {SETTING_ID} from '~~/interface/Setting'
import { RunMode } from "~~/interface/Pos";
import { CloudSyncError, forceSyncToCloud } from "~/modules/pos/composables/useCloudSync";
import { requestRunMode } from "~/modules/seat/utils/seatStorage";
const { t } = useI18n({ useScope: "local" });

// commit ที่ใช้ build ชุดนี้ ฝังไว้ตอน build (ดู buildInfo.ts)
const buildInfo = computed(
  () => useRuntimeConfig().public.buildInfo || {}
);
const buildAt = computed(() =>
  buildInfo.value.builtAt
    ? dayjs(buildInfo.value.builtAt).format("DD/MM/YYYY HH:mm")
    : ""
);

// channel ที่ build ชุดนี้เป็นของมัน = doc app_control ที่เครื่องนี้ฟังอยู่
// เอามาโชว์คู่กับ commit เพราะเวลาซัพพอร์ตถามว่า "ทำไมประกาศไม่ขึ้น" คำตอบมักอยู่ตรงนี้
const buildChannel = useBuildChannel();

// ต้องกด 5 ครั้งภายใน 5 วินาที ไม่งั้นเริ่มนับใหม่
const showBuildInfo = ref(false);
const versionTaps = ref([]);
const tapVersion = () => {
  const now = Date.now();
  versionTaps.value = [...versionTaps.value, now].filter((t) => now - t < 5000);

  if (versionTaps.value.length >= 5) {
    versionTaps.value = [];
    showBuildInfo.value = !showBuildInfo.value;
  }
};

const activeNav = ref("Dashboard");
const navList = ref([]);

const authStore = useAuthStore();
const userStore = useUserStore();
const shopStore = useShopStore();
const jobsStore = useJobsStore();
const posStore = usePosStore();
const employeePin = useEmployeePinStore();
const productsStore = useProductsStore();
const settingsStore = useSettingsStore();
const onlineStatusStore = useOnlineStatusStore();
const { locale, setLocale } = useI18n();

const loading = computed(() => {
  return posStore.loading || productsStore.loading;
});

const currentShift = computed(() =>
  useShiftWork(jobsStore.jobs).getCurrentShiftWorkNumber()
);

// ข้อมูลเครื่องอยู่ใน localStorage ของเครื่องนี้ (ตั้งค่าได้ที่หน้า settings/computer-name)
const computerUuidRef = useLocalStorage("computerUuid", "");

const computerId = computed(() => computerUuidRef.value);

const displayExpireDate = computed(() => {
  if (!shopStore.expireDate) {
    return "";
  }

  const expireData = remainingDate(shopStore.expireDate);
  if (expireData.days < 25) {
    return `(${expireData.days < 0 ? 0 : expireData.days} วัน)`;
  }
});

const mappingPrinterUrl = computed(() => {
  let printerPort = localStorage.getItem("printerPort");
  if (printerPort && printerPort != "") {
    return "http://localhost:" + printerPort;
  }
  return "http://localhost:9090";
});

const remainingExpireDate = computed(() => {
  if (!shopStore.expireDate) {
    return 10000; //not set expire date
  }

  const expireData = remainingDate(shopStore.expireDate);
  return expireData.days;
});

const open = ref(false);
const hoverUserIcon = ref(false);
const runningTime = ref("");
const forceOpenUserIcon = ref(true);

const HEIGHT_REMAINING = useSetElementHight(0);
//on window resize, calculate new height
window.addEventListener("resize", () => {
  const h = useSetElementHight(0);
  if (h.value < 500) {
    HEIGHT_REMAINING.value = 700;
  } else {
    HEIGHT_REMAINING.value = h.value;
  }
});

onMounted(() => {
  computeNewRunningTime();
  setInterval(computeNewRunningTime, 1000 * 60);
});

function computeNewRunningTime() {
  // ให้ navbar แดงเองเมื่อเลยเวลาตัดรอบวัน โดยไม่ต้อง reload
  jobsStore.tickNow();
  let ts = jobsStore.openShop?.timestamp;

  if (ts) {
    runningTime.value = useRuningTimeDateFormat(ts);
  }
}
watch(
  () => jobsStore.openShop,
  (val) => {
    if (val) {
      computeNewRunningTime();
    }
  }
);

//Init Language
watch(
  () => userStore.user,
  (val) => {
    if (val) {
      setLocale(val.locale || "th");
    }
  }
);

// ยังไม่เลือกโหมด — ซ่อนปุ่มแดชบอร์ด + ลิงก์ปิดร้าน (ทั้งหมดไปหน้า /dashboard)
// middleware seat-run-mode ของ modules/seat กัน /dashboard ไว้ ไม่ควรมีปุ่มให้กด
// หน้าอื่นในแถบซ้าย (รายงาน, เมนู, ตั้งค่า ฯลฯ) ยังใช้ได้ตามปกติ
// getMode() ไม่ reactive จึงอ่านใหม่ทุกครั้งที่เปลี่ยนหน้า
const route = useRoute();
const isUnassigned = computed(() => {
  void route.fullPath;
  return useRunningMode().getMode() === RunMode.UNASSIGNED;
});

//Watch Locale
watchEffect(() => {
  const navLists= [
    {
      name: t("sidebar.label.dashboard"),
      icon: "fa-regular fa-house",
      link: "/dashboard/receipts",
      // ยังไม่เลือกโหมด เข้า dashboard ไม่ได้ (middleware seat-run-mode) — ซ่อนปุ่มด้วย
      isShow: !isUnassigned.value,
    },
    {
      name: t("sidebar.label.tables"),
      icon: "fa-regular fa-utensils",
      link: "/pos",
      isShow: true,
    },

    {
      name: t("sidebar.label.history"),
      icon: "fa-regular fa-rectangle-history",
      link: "/logs",
      isShow: true,
    },
    // {
    //   name: t("sidebar.label.check_printer"),
    //   icon: "fa-regular fa-print",
    //   link: "/check-printer",
    // },
    {
      name: t("sidebar.label.reports"),
      icon: "fa-solid fa-chart-line",
      link: "/reports",
      isShow: true,
    },
    {
      name: t("sidebar.label.menu"),
      icon: "fa-regular fa-burger-soda",
      link: "/menu",
      isShow: true,
    },

    {
      name: t("sidebar.label.inventory"),
      icon: "fa-regular fa-truck-ramp-box",
      link: "/inventory/list",
      isShow: true,
    },
    {
      name: t("sidebar.label.expense"),
      icon: "fa-regular fa-receipt",
      link: "/expenses",
      isShow: settingsStore.getValueBysettingId(SETTING_ID.SHOW_EXPENSE, false),
    },
    {
      name: t("sidebar.label.settings"),
      icon: "fa-regular fa-gear",
      link: "/settings",
      isShow: true,
    },
  ];

  navList.value = navLists.filter((item) => item.isShow);
});

const employee = computed(() => {

  return employeePin.employee;
});

//debounce hover mouse leave
const hoverUserIconDebounce = useDebounce(hoverUserIcon, 250);

const shopName = computed(() => {
  return shopStore?.name || "Shop Name"
  // return settingsStore.getValueBysettingId("name", "Shop Name");
});

// ชื่อแท็บเบราว์เซอร์ : ร้านหนึ่งเปิดหลายแท็บ/หลายเครื่อง ต้องแยกออกว่าแท็บไหนของร้านไหน
// ชื่อร้านมาทีหลัง (โหลดจาก store) จึงต้องเป็น computed ไม่ใช่ค่าคงที่ตอน mount
useHead({
  title: computed(() =>
    shopStore?.name ? `xTable POS : ${shopStore.name}` : "xTable POS"
  ),
});

const displayDate = useDisplayDate;

const toggle = () => {
  open.value = !open.value;
};

const lockScreen = () => {
  employeePin.lockScreen();
};

const clearJobs = () => {
  const username = useStorage("storeId", null);
  username.value = null;
  jobsStore.clearJobs();
};

const changeModePos = () => {
  // ฝาก request ให้ plugin seatRequest (modules/seat) คืนที่นั่ง Main / Second
  // แล้วล้างโหมดตอน boot — ล้างในเครื่องทันทีด้วย เผื่อ plugin ทำไม่ได้
  useRunningMode().clear();
  requestRunMode(RunMode.UNASSIGNED, { storeId: useFirebase().getStoreId() || null });
};

const remainingDate = (expireDate) => {
  let currentDate = dayjs();
  let diffInDays = dayjs(expireDate).diff(currentDate, "day"); // คำนวณความต่างเป็นวัน
  let remainingHours = dayjs(expireDate).diff(currentDate, "hour") % 24; // ชั่วโมงที่เหลือหลังหักวัน

  return {
    days: diffInDays,
    hours: diffInDays > 0 || remainingHours > 0 ? remainingHours : 0, // ถ้าวันหมดอายุแสดงชั่วโมงที่เหลือ
  };
};

// ปุ่ม logout ที่ผู้ใช้กดเอง: ร้าน beta บน app2 ออกจาก xtable.co ด้วย (ดู auth.ts)
const logout = () => {
  authStore.logout({ everywhere: true });
};

// ---------- Sync to Cloud ----------
// โหมดเครื่องเปลี่ยนแล้ว reload ทุกครั้ง (changeModePos) อ่านครั้งเดียวพอ
const isMainCashier = useRunningMode().getMode() === RunMode.MAIN_CASHIER;

const syncingToCloud = ref(false);
const canSyncToCloud = computed(() => isMainCashier && !syncingToCloud.value);

const syncToCloud = async () => {
  if (!canSyncToCloud.value) return; // กันกดซ้ำระหว่างรอ
  syncingToCloud.value = true;
  try {
    const res = await forceSyncToCloud();
    useToastStore().show({
      message: t("navbar.menu.sync_to_cloud_done", { total: res.total }),
      type: "success",
    });
  } catch (e) {
    console.warn("[syncToCloud]", e);
    const code = e instanceof CloudSyncError ? e.code : null;
    useToastStore().show({
      message: code
        ? t(`navbar.menu.sync_to_cloud_error.${code}`)
        : `${t("navbar.menu.sync_to_cloud_failed")}: ${e?.message || e}`,
      type: "error",
    });
  } finally {
    syncingToCloud.value = false;
  }
};
</script>

<style></style>
